import { useMemo } from 'react';
import MediaService from '../../../../../utils/DeviationMediaService';
export default function useBestFittingImage(deviation, containerWidth, containerHeight) {
    const pickedImage = useMemo(()=>MediaService.getFullviewForSize(deviation, containerWidth, containerHeight), [
        containerHeight,
        containerWidth,
        deviation
    ]);
    return pickedImage;
}
